export default {
  errors: {
    googleNotAvailable: 'El acceso con Google aún no está disponible para esta cuenta. Para continuar, introduce tu contraseña.',
  },
  passwordUpdate: {
    modal: {
      chat: {
        text: 'Nuestros agentes están disponibles de lunes a viernes entre las {start} y las {end}.',
      },
    },
  },
  register: {
    title: '<span class="text-2xl font-semibold text-slate-700">Facturar gratis es posible</span> <br /> <span class="text-base text-slate-500 font-normal">Con Alegra lo haces fácil, seguro y sin tarjeta</span>',
  }
}
